(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jm-herinner-mij"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KLAVIYO_REVISION = '2026-07-15';
    const SUBSCRIBED_KEY = 'jm-hm-subscribed';
    const CARD_LINK = '.card-product a[x-labels-data]';
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const productCache = new Map();
    let state = null;

    const getRoot = () => document.querySelector('[data-jm-hm-root]');

    const remember = (variantId) => {
      try {
        const list = JSON.parse(localStorage.getItem(SUBSCRIBED_KEY) || '[]').map(String);
        if (!list.includes(variantId)) list.push(variantId);
        localStorage.setItem(SUBSCRIBED_KEY, JSON.stringify(list.slice(-50)));
      } catch (e) {}
    };

    /* ---------- Productdata (productkaarten halen die op via /products/<handle>.js) ---------- */

    const sized = (src) => {
      if (!src) return null;
      const url = src.startsWith('//') ? `https:${src}` : src;
      return `${url}${url.includes('?') ? '&' : '?'}width=240`;
    };

    const normalize = (p) => ({
      title: p.title,
      handle: p.handle,
      single: p.variants.length === 1 && p.variants[0].title === 'Default Title',
      options: (p.options || []).map((o) => (typeof o === 'string' ? o : o.name)),
      image: sized(p.featured_image),
      variants: p.variants.map((v) => ({
        id: v.id,
        // Optiewaarden i.p.v. de varianttitel: die volgen gegarandeerd de vertalingen van de winkel.
        title: v.options && v.options.length ? v.options.join(' / ') : v.title,
        available: v.available,
        image: sized(v.featured_image && v.featured_image.src),
      })),
    });

    const fetchProduct = (handle) => {
      if (!productCache.has(handle)) {
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const request = fetch(`${base}products/${encodeURIComponent(handle)}.js`)
          .then((res) => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
          })
          .then(normalize)
          .catch((error) => {
            productCache.delete(handle);
            throw error;
          });
        productCache.set(handle, request);
      }
      return productCache.get(handle);
    };

    /* ---------- Pop-up ---------- */

    const parts = (dialog) => ({
      form: dialog.querySelector('[data-jm-hm-form]'),
      formStep: dialog.querySelector('[data-jm-hm-step="form"]'),
      doneStep: dialog.querySelector('[data-jm-hm-step="done"]'),
      image: dialog.querySelector('[data-jm-hm-image]'),
      title: dialog.querySelector('[data-jm-hm-title]'),
      variant: dialog.querySelector('[data-jm-hm-variant]'),
      variantField: dialog.querySelector('[data-jm-hm-variant-field]'),
      variantLabel: dialog.querySelector('[data-jm-hm-variant-label]'),
      select: dialog.querySelector('[data-jm-hm-select]'),
      error: dialog.querySelector('[data-jm-hm-error]'),
      submit: dialog.querySelector('[data-jm-hm-submit]'),
      success: dialog.querySelector('[data-jm-hm-success]'),
    });

    const currentVariant = () =>
      state && (state.product.variants || []).find((v) => String(v.id) === state.variantId);

    const productName = () => {
      const variant = currentVariant();
      return !state.product.single && variant ? `${state.product.title} (${variant.title})` : state.product.title;
    };

    const fill = (dialog) => {
      const p = parts(dialog);
      const { product } = state;
      const variant = currentVariant();
      const soldOut = (product.variants || []).filter((v) => !v.available);
      const showSelect = !state.lockVariant && !product.single && soldOut.length > 1;

      p.title.textContent = product.title || '';
      p.variant.textContent = !product.single && variant ? variant.title : '';
      p.variant.hidden = showSelect || !p.variant.textContent;

      const src = (variant && variant.image) || product.image;
      p.image.hidden = !src;
      if (src && p.image.getAttribute('src') !== src) p.image.src = src;

      p.variantField.hidden = !showSelect;
      if (showSelect) {
        p.variantLabel.textContent = (product.options || []).join(' / ') || p.variantLabel.dataset.fallback;
        p.select.replaceChildren(
          ...soldOut.map((v) => new Option(v.title, v.id, false, String(v.id) === state.variantId))
        );
      }
    };

    const showStep = (dialog, step) => {
      const p = parts(dialog);
      p.formStep.hidden = step !== 'form';
      p.doneStep.hidden = step !== 'done';
      dialog.setAttribute('aria-labelledby', `jm-hm-heading-${step}`);
    };

    const setError = (dialog, message) => {
      const p = parts(dialog);
      p.error.textContent = message || '';
      p.error.hidden = !message;
      p.form.email.toggleAttribute('aria-invalid', Boolean(message));
    };

    const open = (detail) => {
      const root = getRoot();
      const dialog = root && root.querySelector('[data-jm-hm-dialog]');
      if (!dialog) return;

      state = {
        product: detail.product || detail.fallback || { title: '', variants: [], single: true },
        variantId: String(detail.variantId),
        handle: detail.handle || (detail.product && detail.product.handle),
        trigger: detail.trigger,
        lockVariant: Boolean(detail.lockVariant),
      };

      const p = parts(dialog);
      setError(dialog, '');
      p.submit.removeAttribute('aria-busy');
      showStep(dialog, 'form');
      fill(dialog);

      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('jm-hm-lock');
      // Op touch-apparaten niet meteen het toetsenbord openen.
      if (window.matchMedia('(pointer: fine)').matches) p.form.email.focus({ preventScroll: true });

      if (!detail.product && state.handle) {
        const handle = state.handle;
        fetchProduct(handle)
          .then((product) => {
            if (!state || state.handle !== handle) return;
            state.product = product;
            fill(dialog);
          })
          .catch(() => {});
      }
    };

    const fillSuccess = (target, template, values) => {
      target.replaceChildren();
      template.split(/(\[email\]|\[product\])/).forEach((part) => {
        if (part === '[email]' || part === '[product]') {
          const strong = document.createElement('strong');
          strong.textContent = values[part.slice(1, -1)];
          target.append(strong);
        } else if (part) {
          target.append(part);
        }
      });
    };

    const klaviyo = (endpoint, companyId, body) =>
      fetch(`https://a.klaviyo.com/client/${endpoint}?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(body),
      });

    const submit = async (event) => {
      event.preventDefault();
      const root = getRoot();
      const dialog = root.querySelector('[data-jm-hm-dialog]');
      const p = parts(dialog);
      const email = p.form.email.value.trim();
      const companyId = root.dataset.company;

      if (!EMAIL_RE.test(email)) {
        setError(dialog, root.dataset.errorEmail);
        p.form.email.focus();
        return;
      }
      if (!companyId || !state) {
        console.warn('[JM · Herinner mij] Vul de publieke Klaviyo API-sleutel in bij de sectie.');
        setError(dialog, root.dataset.errorGeneral);
        return;
      }

      setError(dialog, '');
      p.submit.setAttribute('aria-busy', 'true');
      const variantId = state.variantId;

      try {
        const res = await klaviyo('back-in-stock-subscriptions', companyId, {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email } } },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } },
            },
          },
        });

        if (!res.ok) {
          const body = await res.json().catch(() => null);
          const detail = (body && body.errors && body.errors[0]) || {};
          console.warn('[JM · Herinner mij] Klaviyo:', res.status, detail.code, detail.detail);
          const emailProblem = res.status === 400 && /e-?mail/i.test(`${detail.detail} ${detail.source && detail.source.pointer}`);
          setError(dialog, emailProblem ? root.dataset.errorEmail : root.dataset.errorGeneral);
          return;
        }

        const listId = root.dataset.list;
        if (listId && p.form.newsletter && p.form.newsletter.checked) {
          klaviyo('subscriptions', companyId, {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Herinner mij (website)',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } },
                  },
                },
              },
              relationships: { list: { data: { type: 'list', id: listId } } },
            },
          }).catch(() => {});
        }

        // Taal van de bezoeker op het profiel, zodat de flow de mail in de juiste taal kan sturen.
        const shopify = window.Shopify || {};
        const lang = String(shopify.locale || document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
        const profile = { email, properties: { Taal: lang } };
        if (shopify.country) profile.locale = `${lang}-${String(shopify.country).toUpperCase()}`;
        klaviyo('profiles', companyId, { data: { type: 'profile', attributes: profile } }).catch(() => {});

        remember(variantId);
        document.dispatchEvent(new CustomEvent('jm-hm:subscribed', { detail: { variantId, email } }));
        fillSuccess(p.success, root.dataset.success || '', { email, product: productName() });
        showStep(dialog, 'done');
        dialog.querySelector('#jm-hm-heading-done').focus({ preventScroll: true });
      } catch (error) {
        console.warn('[JM · Herinner mij]', error);
        setError(dialog, root.dataset.errorGeneral);
      } finally {
        p.submit.removeAttribute('aria-busy');
      }
    };

    const bindDialog = (root) => {
      const dialog = root.querySelector('[data-jm-hm-dialog]');
      if (!dialog || dialog.dataset.jmHmReady !== undefined) return;
      dialog.dataset.jmHmReady = '';
      const p = parts(dialog);

      p.form.addEventListener('submit', submit);
      p.form.email.addEventListener('input', () => setError(dialog, ''));
      p.select.addEventListener('change', () => {
        state.variantId = String(p.select.value);
        fill(dialog);
      });
      dialog.querySelectorAll('[data-jm-hm-close]').forEach((btn) => btn.addEventListener('click', () => dialog.close()));

      // Klik op de achtergrond sluit (alleen als de klik daar ook begon).
      let downOnBackdrop = false;
      dialog.addEventListener('pointerdown', (event) => {
        downOnBackdrop = event.target === dialog;
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog && downOnBackdrop) dialog.close();
      });

      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('jm-hm-lock');
        const trigger = state && state.trigger;
        if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
        p.form.reset();
      });
    };

    /* ---------- Productkaarten ---------- */

    const cardEntry = (link) => {
      let data;
      try {
        data = JSON.parse(link.getAttribute('x-labels-data'));
      } catch (e) {
        return null;
      }
      if (!Array.isArray(data) || !data.length) return null;
      let entry = data[0];
      const current = link.closest('.card-product')?.querySelector('.current-variant');
      if (current) {
        try {
          const parsed = JSON.parse(current.textContent);
          const id = Number(typeof parsed === 'object' ? parsed.id : parsed);
          entry = data.find((d) => d.variant_id === id) || entry;
        } catch (e) {}
      }
      return entry;
    };

    const handleFrom = (href) => {
      const match = (href || '').match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    };

    const placeLabel = (link, label, position) => {
      // In de Eurus-labelcontainer op dezelfde hoek, zodat hij netjes onder "Nieuw" komt.
      const stack = link.querySelector(`.${position}-container`);
      const target = stack || link;
      if (label.parentElement !== target) target.append(label);
      label.classList.remove('jm-hm-pos--top-right', 'jm-hm-pos--top-left');
      if (!stack) label.classList.add(`jm-hm-pos--${position}`);
    };

    const applyCard = (link, config) => {
      const card = link.closest('.card-product');
      const entry = cardEntry(link);
      const soldOut = Boolean(entry) && entry.available === false;
      let label = link.querySelector('.jm-hm-badge');
      let button = link.querySelector(':scope > .jm-hm-card-btn');

      card.classList.toggle('jm-hm-card', soldOut && Boolean(config.button));
      link.classList.toggle('jm-hm-media', soldOut && Boolean(config.label));
      if (!soldOut) {
        label?.remove();
        button?.remove();
        return;
      }

      if (config.label) {
        if (!label) label = config.labelTemplate.content.firstElementChild.cloneNode(true);
        placeLabel(link, label, config.position);
      } else {
        label?.remove();
      }

      if (!config.button) button?.remove();
      if (config.button && !button) {
        button = config.buttonTemplate.content.firstElementChild.cloneNode(true);
        const title = link.getAttribute('aria-label') || '';
        button.setAttribute('aria-label', `${button.textContent.trim()}: ${title}`);
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const current = cardEntry(link);
          const image = link.querySelector('img');
          open({
            handle: handleFrom(link.getAttribute('href')),
            variantId: current ? current.variant_id : entry.variant_id,
            trigger: button,
            fallback: {
              title,
              image: image ? image.currentSrc || image.src : null,
              single: true,
              variants: [],
            },
          });
        });
        // In de afbeeldingslink, net als de Eurus-snelkoopknop; de klik wordt hierboven afgevangen.
        link.append(button);
      }
    };

    const scan = () => {
      const root = getRoot();
      if (!root) {
        document.querySelectorAll('.jm-hm-badge, .jm-hm-card-btn').forEach((node) => node.remove());
        document.querySelectorAll('.jm-hm-card, .jm-hm-media').forEach((el) => el.classList.remove('jm-hm-card', 'jm-hm-media'));
        return;
      }
      bindDialog(root);
      const config = {
        label: root.dataset.cardsLabel === 'true',
        button: root.dataset.cardsButton === 'true',
        position: root.dataset.position || 'top-right',
        labelTemplate: root.querySelector('template[data-jm-hm-card-label]'),
        buttonTemplate: root.querySelector('template[data-jm-hm-card-button]'),
      };
      document.querySelectorAll(CARD_LINK).forEach((link) => applyCard(link, config));
    };

    // Kaarten die later binnenkomen (filters, oneindig scrollen, aanbevelingen, Eurus-labels).
    let queued = false;
    const queueScan = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        scan();
      });
    };
    const isOwn = (node) => node.nodeType === 1 && /\bjm-hm-/.test(node.className);

    const start = () => {
      scan();
      new MutationObserver((mutations) => {
        const relevant = mutations.some(
          (m) =>
            m.type === 'attributes' ||
            [...m.addedNodes].some((n) => n.nodeType === 1 && !isOwn(n)) ||
            [...m.removedNodes].some(isOwn)
        );
        if (relevant) queueScan();
      }).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['x-labels-data'],
      });
    };

    document.addEventListener('jm-hm:open', (event) => open(event.detail));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', queueScan);
    document.addEventListener('shopify:section:unload', () => setTimeout(scan));
  })();

  } catch(e) { console.error(e); }
})();
})();
